module.exports = __webpack_public_path__ + "static/media/Test46.14953109.bmp";